import * as firebase from "firebase/app";

import React, { Component } from "react";

import Footer from "../Footer";
import Meta from "../../helpers/meta";
import Nav from "../Nav";
import { Redirect } from "react-router";
import { connect } from "react-redux";
import { getPromoSlides } from "../../../services/promoSlider/actions";
import { NavLink } from "react-router-dom";
import {
  GET_SINGLE_ORDER_TO_BE_RATED,
  GET_RESTAURANTS_SLIDES_URL,
} from "../../../configs/index";

import messaging from "../../../init-fcm";
import { saveNotificationToken } from "../../../services/notification/actions";
import { getSingleLanguageData } from "../../../services/languages/actions";
import { getUserNotifications } from "../../../services/alert/actions";
import { resetInfo, resetItems } from "../../../services/items/actions";
import TagSlider from "./TagSlider";
import Ink from "react-ink";
import axios from "axios";
import DelayLink from "../../helpers/delayLink";
import { Link, withRouter } from "react-router-dom";
import StoreTypeSlider from "./StoreTypeSlider";
import Coupons from "./Coupons";
import PromoSlider from "./PromoSlider";
// import moment from "moment";
import QuickBites from "./QuickBites";
import RestaurantList from "./RestaurantList";
import ItemList from "./ItemList";
import PromoSliderV2 from "./PromoSliderV2";
import RestaurantHorizontalList from "./RestaurantHorizontalList";
import UpdateModal from "./UpdateModal";

class HomeFront extends Component {
  static contextTypes = {
    router: () => null,
  };

  state = {
    tags: [],
    data: [],
    restaurants: [],
    popular_restaurants: [],
  };

  getAllRestaurantSliders = () => {
    axios.post(GET_RESTAURANTS_SLIDES_URL).then((response) => {
      if (response.data) {
        this.setState({
          data: response.data,
        });
      }
    });
  };

  changeRouteToRestaurantsCategories = (categories) => {
    if (categories.categories_ids) {
      const saveCategorySelectOptions = new Promise((resolve) => {
        localStorage.setItem(
          "categorySelectOptions",
          JSON.stringify(categories.categories_ids)
        );
        resolve("categorySelectOptions Saved");
      });
      saveCategorySelectOptions.then(() => {
        this.props.history.push("categories/stores");
      });
    }
  };
  async componentDidMount() {
    this.props.resetItems();
    this.props.resetInfo();

    this.getAllRestaurantSliders();

    const { user } = this.props;

    //if currentLocation doesnt exists in localstorage then redirect the user to firstscreen
    //else make API calls
    if (localStorage.getItem("userSetAddress") !== null) {
      // this.context.router.history.push("/search-location");
      // console.log("Redirect to search location");
      // return <Redirect to="/search-location" />;

      const userSetAddress = JSON.parse(localStorage.getItem("userSetAddress"));

      this.props.getPromoSlides(userSetAddress.lat, userSetAddress.lng);

      axios
        .post("https://pykin.in/public/api/get-home-featured", {
          latitude: userSetAddress.lat,
          longitude: userSetAddress.lng,
        })
        .then((response) => {
          const restaurants = response.data;
          if (restaurants.length) {
            // add new
            this.setState({
              total: restaurants.length,
              popular_restaurants: restaurants,
              city_id: restaurants[0].city_id,
            });
          } else {
            this.setState({
              total: null,
              loading: false,
              loading_more: false,
              no_restaurants: true,
            });
          }
        });

      const { user } = this.props;

      if (user.success) {
        this.props.getUserNotifications(user.data.id, user.data.auth_token);
      }
    } else {
      //call to promoSlider API to fetch the slides
    }

    if (user.success) {
      if (localStorage.getItem("enablePushNotification") === "true") {
        if (firebase.messaging.isSupported()) {
          let handler = this.props.saveNotificationToken;
          messaging
            .requestPermission()
            .then(async function() {
              const push_token = await messaging.getToken();
              handler(push_token, user.data.id, user.data.auth_token);
              // localStorage.setItem("lastSavedNotificationToken", today);
            })
            .catch(function(err) {
              console.log("Unable to get permission to notify.", err);
            });
          // }
        }
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.languages !== nextProps.languages) {
      if (localStorage.getItem("userPreferedLanguage")) {
        this.props.getSingleLanguageData(
          localStorage.getItem("userPreferedLanguage")
        );
      } else {
        if (nextProps.languages.length) {
          // console.log("Fetching Translation Data...");
          const id = nextProps.languages.filter(
            (lang) => lang.is_default === 1
          )[0].id;
          this.props.getSingleLanguageData(id);
        }
      }
    }
  }

  componentWillUnmount() {
    // navigator.serviceWorker.removeEventListener("message", message => console.log(message));
  }

  render() {
    if (window.innerWidth > 768) {
      return <Redirect to='/' />;
    }

    if (localStorage.getItem("userSetAddress") === null) {
      // this.context.router.history.push("/search-location");
      // console.log("Redirect to search location");
      return <Redirect to='/search-location' />;
    }

    const userSetAddress = JSON.parse(localStorage.getItem("userSetAddress"));
    if (
      Object.keys(userSetAddress).length === 0 &&
      userSetAddress.constructor === Object
    ) {
      return <Redirect to='/search-location' />;
    }

    const { history, user, promo_slides } = this.props;

    // console.log(promo_slides.mainSlides.length);

    // Check if update modal should be shown (same logic as UpdateModal)
    const currentPath = this.props.location ? this.props.location.pathname : window.location.pathname;
    const isDeliveryRoute = currentPath.startsWith("/delivery");
    const isHomeRoute = currentPath === "/" || currentPath === "/home-front";
    const shouldShowUpdateModal = !isDeliveryRoute && isHomeRoute;

    return (
      <React.Fragment>
        <UpdateModal />
        <Meta
          seotitle={localStorage.getItem("seoMetaTitle")}
          seodescription={localStorage.getItem("seoMetaDescription")}
          ogtype='website'
          ogtitle={localStorage.getItem("seoOgTitle")}
          ogdescription={localStorage.getItem("seoOgDescription")}
          ogurl={window.location.href}
          twittertitle={localStorage.getItem("seoTwitterTitle")}
          twitterdescription={localStorage.getItem("seoTwitterDescription")}
        />
        {/* <div className="bg-white p-2 sticky-custom-header" style={{"boxShadow":"rgb(0 0 0 / 8%) 0px 2px 5px","position":"sticky","zIndex":"1","top":"-1px"}}>
						<div className="row">
							<div className="col-6">
								<button
									type="submit"
									className="btn w-100 bg-white text-left truncate-text"
									style={{ position: "relative", maxWidth: '90%',padding: '8px' }}
									onClick={() => {
										this.props.loggedin
											? this.context.router.history.push("/my-addresses")
											: this.context.router.history.push("/search-location");
									}}
								>
									{localStorage.getItem("userSetAddress") && (
										<React.Fragment>
											<span>
												<span style={{marginRight: '7px'}}><i className="si si-pointer"/></span>
												{JSON.parse(localStorage.getItem("userSetAddress")).tag !== null ? (
													<strong className="text-uppercase mr-1">
														{JSON.parse(localStorage.getItem("userSetAddress")).tag}
													</strong>
												) : null}

												{JSON.parse(localStorage.getItem("userSetAddress")).house !==
													null ? (
													<span>
														{JSON.parse(localStorage.getItem("userSetAddress")).address
															.length > 11
															? `${JSON.parse(
																localStorage.getItem("userSetAddress")
															).address.substring(0, 11)}...`
															: JSON.parse(localStorage.getItem("userSetAddress"))
																.address}
													</span>
												) : (
													<span>
														{JSON.parse(localStorage.getItem("userSetAddress")).address
															.length > 11
															? `${JSON.parse(
																localStorage.getItem("userSetAddress")
															).address.substring(0, 11)}...`
															: JSON.parse(localStorage.getItem("userSetAddress"))
																.address}
													</span>
												)}
											</span>
										</React.Fragment>
									)}
									<i
										className="si si-arrow-down pull-right mt-1 nav-location-icon ml-1"
										style={{ color: localStorage.getItem("storeColor") }}
									/>
									<Ink duration="500" />
								</button></div>

							<NavLink to="/alerts" className="col text-right mt-5 ">
								<span
									className="cart-quantity-badge"
									style={{ backgroundColor: localStorage.getItem("storeColor"), left: '83%' }}
								>
									{this.props.alertUnreadTotal}
								</span>
								<i className="si si-bell fa-2x" />
							</NavLink>
							<DelayLink to={'/coupons'} style={{paddingLeft: '0%'}} className="col-2 mt-5"><span className="font-weight-bold">OFFERS</span><Ink duration="500" /></DelayLink>

						</div>
					</div> */}
        <div
          className='height-100-percent bg-white mb-100'
          style={{ padding: "7px" }}>
          <div
            style={{
              display: "flex",
              padding: "10px",
              justifyContent: "space-between",
            }}>
            <div>
              <div
                style={{
                  fontSize: "20px",
                  fontStyle: "normal",
                  fontWeight: "600",
                }}>
                Welcome {user.success ? ", " + user.data.name : " to Pykin"}
              </div>
              <div
                onClick={() => {
                  this.props.loggedin
                    ? this.context.router.history.push("/my-addresses")
                    : this.context.router.history.push("/search-location");
                }}>
                <svg
                  width='9'
                  height='11'
                  viewBox='0 0 9 11'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'>
                  <path
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    d='M0 4.80499C0 2.12793 2.00685 0 4.53161 0C7.05636 0 9.06321 2.12793 8.99848 4.80499C8.99848 6.1092 8.54532 7.34477 7.63899 8.23713C7.63899 8.28846 6.1547 9.68332 5.37898 10.4123C5.11737 10.6581 4.93636 10.8282 4.92003 10.8456C4.72582 11.0515 4.3374 11.0515 4.07845 10.8456C4.04608 10.8112 3.38252 10.1763 2.71896 9.54134C2.05541 8.9064 1.39185 8.27145 1.35948 8.23713C0.453161 7.34477 0 6.1092 0 4.80499ZM3.23676 4.80512C3.23676 5.56019 3.81939 6.17797 4.5315 6.17797C5.24361 6.17797 5.82625 5.56019 5.82625 4.80512C5.82625 4.05005 5.24361 3.43226 4.5315 3.43226C3.81939 3.43226 3.23676 4.05005 3.23676 4.80512Z'
                    fill='#ED0101'
                  />
                </svg>{" "}
                {localStorage.getItem("userSetAddress") && (
                  <span>
                    {JSON.parse(localStorage.getItem("userSetAddress")).tag !==
                    null ? (
                      <strong className='text-uppercase mr-1'>
                        {JSON.parse(localStorage.getItem("userSetAddress")).tag}
                      </strong>
                    ) : null}

                    {JSON.parse(localStorage.getItem("userSetAddress"))
                      .house !== null ? (
                      <span>
                        {JSON.parse(localStorage.getItem("userSetAddress"))
                          .address.length > 11
                          ? `${JSON.parse(
                              localStorage.getItem("userSetAddress")
                            ).address.substring(0, 11)}...`
                          : JSON.parse(localStorage.getItem("userSetAddress"))
                              .address}
                      </span>
                    ) : (
                      <span>
                        {JSON.parse(localStorage.getItem("userSetAddress"))
                          .address.length > 11
                          ? `${JSON.parse(
                              localStorage.getItem("userSetAddress")
                            ).address.substring(0, 11)}...`
                          : JSON.parse(localStorage.getItem("userSetAddress"))
                              .address}
                      </span>
                    )}
                  </span>
                )}{" "}
                <svg
                  width='12'
                  height='12'
                  viewBox='0 0 12 12'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'>
                  <path
                    d='M7.5 11.375H4.5C1.785 11.375 0.625 10.215 0.625 7.5V4.5C0.625 1.785 1.785 0.625 4.5 0.625H5.5C5.705 0.625 5.875 0.795 5.875 1C5.875 1.205 5.705 1.375 5.5 1.375H4.5C2.195 1.375 1.375 2.195 1.375 4.5V7.5C1.375 9.805 2.195 10.625 4.5 10.625H7.5C9.805 10.625 10.625 9.805 10.625 7.5V6.5C10.625 6.295 10.795 6.125 11 6.125C11.205 6.125 11.375 6.295 11.375 6.5V7.5C11.375 10.215 10.215 11.375 7.5 11.375Z'
                    fill='#524F4F'
                  />
                  <path
                    d='M4.25001 8.84503C3.94501 8.84503 3.66501 8.73503 3.46001 8.53503C3.21501 8.29003 3.11001 7.93503 3.16501 7.56003L3.38001 6.05503C3.42001 5.76503 3.61001 5.39003 3.81501 5.18503L7.75501 1.24503C8.75001 0.250029 9.76001 0.250029 10.755 1.24503C11.3 1.79003 11.545 2.34503 11.495 2.90003C11.45 3.35003 11.21 3.79003 10.755 4.24003L6.81501 8.18003C6.61001 8.38503 6.23501 8.57503 5.94501 8.61503L4.44001 8.83003C4.37501 8.84503 4.31001 8.84503 4.25001 8.84503ZM8.28501 1.77503L4.34501 5.71503C4.25001 5.81003 4.14001 6.03003 4.12001 6.16003L3.90501 7.66503C3.88501 7.81003 3.91501 7.93003 3.99001 8.00503C4.06501 8.08003 4.18501 8.11003 4.33001 8.09003L5.83501 7.87503C5.96501 7.85503 6.19001 7.74503 6.28001 7.65003L10.22 3.71003C10.545 3.38503 10.715 3.09503 10.74 2.82503C10.77 2.50003 10.6 2.15503 10.22 1.77003C9.42001 0.970029 8.87001 1.19503 8.28501 1.77503Z'
                    fill='#524F4F'
                  />
                  <path
                    d='M9.925 4.91501C9.89 4.91501 9.855 4.91001 9.825 4.90001C8.51 4.53001 7.465 3.48501 7.095 2.17001C7.04 1.97001 7.155 1.76501 7.355 1.70501C7.555 1.65001 7.76 1.76501 7.815 1.96501C8.115 3.03001 8.96 3.87501 10.025 4.17501C10.225 4.23001 10.34 4.44001 10.285 4.64001C10.24 4.81001 10.09 4.91501 9.925 4.91501Z'
                    fill='#524F4F'
                  />
                </svg>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "15vw",
                justifyContent: "space-between",
              }}>
              <svg
                width='20'
                height='19'
                viewBox='0 0 20 19'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'>
                <path
                  d='M14.5 0C17.538 0 20 2.5 20 6C20 13 12.5 17 10 18.5C7.5 17 0 13 0 6C0 2.5 2.5 0 5.5 0C7.36 0 9 1 10 2C11 1 12.64 0 14.5 0ZM10.934 15.604C11.815 15.048 12.61 14.495 13.354 13.903C16.335 11.533 18 8.943 18 6C18 3.64 16.463 2 14.5 2C13.424 2 12.26 2.57 11.414 3.414L10 4.828L8.586 3.414C7.74 2.57 6.576 2 5.5 2C3.56 2 2 3.656 2 6C2 8.944 3.666 11.533 6.645 13.903C7.39 14.495 8.185 15.048 9.066 15.603C9.365 15.792 9.661 15.973 10 16.175C10.339 15.973 10.635 15.792 10.934 15.604Z'
                  fill='#242424'
                />
              </svg>

              <svg
                onClick={() => this.context.router.history.push("/alerts")}
                width='30'
                height='31'
                viewBox='0 0 30 31'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'>
                <rect y='1' width='30' height='30' rx='8' fill='white' />
                <g clip-path='url(#clip0_0_1)'>
                  <path
                    d='M23.3333 22.6666H6.66666V21H7.49999V15.1925C7.49999 11.0358 10.8583 7.66663 15 7.66663C19.1417 7.66663 22.5 11.0358 22.5 15.1925V21H23.3333V22.6666ZM9.16666 21H20.8333V15.1925C20.8333 11.9566 18.2217 9.33329 15 9.33329C11.7783 9.33329 9.16666 11.9566 9.16666 15.1925V21ZM12.9167 23.5H17.0833C17.0833 24.0525 16.8638 24.5824 16.4731 24.9731C16.0824 25.3638 15.5525 25.5833 15 25.5833C14.4475 25.5833 13.9176 25.3638 13.5269 24.9731C13.1362 24.5824 12.9167 24.0525 12.9167 23.5Z'
                    fill='#242424'
                  />
                </g>
                <rect
                  x='15'
                  y='2'
                  width='12'
                  height='12'
                  rx='6'
                  fill='#118A45'
                />
                <rect
                  x='15'
                  y='2'
                  width='12'
                  height='12'
                  rx='6'
                  stroke='#F2FBF7'
                  stroke-width='4'
                />
                <defs>
                  <clipPath id='clip0_0_1'>
                    <rect
                      width='20'
                      height='20'
                      fill='white'
                      transform='translate(5 6)'
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
          </div>

          <div className='mt-2 d-flex justify-content-center'>
            <div
              class='input-group search-shadow-light'
              style={{width: '95%'}}
              onClick={() => this.context.router.history.push("/explore")}>
              <input

              style={{"background":"#f5f5f5"}}
                type='text'
                class='form-control items-search-box'
                placeholder='Search'
              />
              <div class='input-group-append'>
                <span class='input-group-text items-search-box-icon'               style={{"background":"#f5f5f5"}}
>
                  <i class='si si-magnifier'></i>
                </span>
              </div>
            </div>
          </div>

          <React.Fragment>
            <div>
              <StoreTypeSlider />
            </div>
            <div className='mt-10' style={{ marginBottom: promo_slides.mainSlides && promo_slides.mainSlides.length == 0 ? "7vw" : "1vw" }}>
              <TagSlider />
            </div>

            {/* <div className='mt-1'>
              {promo_slides &&
                promo_slides.mainSlides &&
                promo_slides.mainSlides.length > 0 && (
                  <React.Fragment>
                    
                    <PromoSlider
                      slides={promo_slides.mainSlides}
                      size={promo_slides.mainSlides[0]["promo_slider"]["size"]}
                    />
                  </React.Fragment>
                )}
            </div> */}
            <div>
              <PromoSliderV2 tags={promo_slides.mainSlides} />
            </div>
            <div>
              <QuickBites />
            </div>
            {/* {this.state.restaurants.length > 0 && (
              <div className='bg-white pt-10 mt-4'>
               
                <div
                  style={{ backgroundColor: "#ffffff" }}
                  className='slider-wrapper secondary-slider-wrapper my-5'>
                  {this.state.restaurants.map(
                    (restaurant, index) =>
                      restaurant.second_image && (
                        <React.Fragment key={restaurant.id}>
                          <DelayLink
                            to={"../stores/" + restaurant.slug}
                            delay={200}>
                            <div
                              style={{
                                backgroundSize: "cover",
                                borderRadius: "12px",
                                backgroundImage:
                                  'url("https://pykin.in' +
                                  restaurant.second_image +
                                  '")',
                                height: "370px",
                                position: "relative",
                                width: "273.625px",
                              }}
                              className='slider-wrapper__img-wrapper'></div>
                          </DelayLink>
                        </React.Fragment>
                      )
                  )}
                </div>
              </div>
            )} */}

            {/* <div className='mt-4'>
              <RestaurantHorizontalList />
            </div> */}

            <div style={{ marginTop: "7vw" }}>
              <RestaurantList
                popular_restaurants={this.state.popular_restaurants}
              />
            </div>

            <div className='mt-4'>
              <ItemList />
            </div>

            {/* <div className='mt-4'>
              <Coupons />
            </div> */}

            <div>
              <React.Fragment>
                {this.state.data.length > 0 && (
                  <>
                    <span
                      style={{
                        fontSize: "large",
                        paddingLeft: "10px",
                        fontWeight: "bold",
                      }}>
                      Top Categories
                    </span>

                    <div className='slider-wrapper secondary-slider-wrapper my-0 bg-white '>
                      {this.state.data.map((category) => (
                        <div
                          className='slider-wrapper__img-wrapper bg-white'
                          key={category.id}>
                          <div
                            style={{ position: "relative" }}
                            onClick={() => {
                              this.changeRouteToRestaurantsCategories(category);
                            }}>
                            <img
                              src={"https://pykin.in" + category.image}
                              alt={category.name}
                              className='slider-wrapper__img slider-cust-img'
                              style={{
                                height: "75px",
                                width: "75px",
                                borderRadius: "100%",
                              }}
                            />
                            {localStorage.getItem(
                              "showRestaurantCategorySliderLabel"
                            ) === "true" && (
                              <span className='category-slider-name'>
                                {category.name}
                              </span>
                            )}
                            <Ink duration='500' hasTouch={true} />
                          </div>
                        </div>
                      ))}
                    </div>
                  </>
                )}
              </React.Fragment>
            </div>

            <div className='mt-2'>
              {this.props.promo_slides.length > 0 && (
                <div
                  className='mb-5 mt-5'
                  style={{
                    fontSize: "large",
                    paddingLeft: "10px",
                    fontWeight: "bold",
                  }}>
                  Quick Links
                </div>
              )}{" "}
              <React.Fragment>
                {this.props.promo_slides && this.props.promo_slides.length > 0 && (
                  <React.Fragment>
                    <PromoSlider
                      slides={this.props.promo_slides}
                      size={this.props.promo_slides[0]["promo_slider"]["size"]}
                      secondarySlider={true}
                    />
                  </React.Fragment>
                )}
              </React.Fragment>
            </div>
          </React.Fragment>

          {!shouldShowUpdateModal && <Footer active_nearme={true} />}
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  promo_slides: state.promo_slides.promo_slides,
  user: state.user.user,
  locations: state.locations.locations,
  languages: state.languages.languages,
  alertUnreadTotal: state.alert.alertUnreadTotal,
});

export default withRouter(connect(mapStateToProps, {
  getPromoSlides,
  saveNotificationToken,
  getSingleLanguageData,
  getUserNotifications,
  resetInfo,
  resetItems,
})(HomeFront));
